import configureRestApi from './configureRestApi';

const BASE_URL = import.meta.env.VITE_BASE_API_URL ?? '';

if (!BASE_URL) {
  console.error('BASE_URL not set in configuration file. Please verify');
}

export const { get, post, put, patch, remove } = configureRestApi(BASE_URL);
